import $ from 'jquery';

$('.js-toggle-approach-graph li a').on('mouseover click', function(e) {
    e.preventDefault();
    
    const href = $( this ).attr( 'href' );
    const getId = href.substr( href.length - 1 );

    $('#ag-image-' + getId).siblings().removeClass('is-active');
    $('#ag-image-' + getId).addClass('is-active');

    $('#ag-content-' + getId).siblings().removeClass('is-active');
    $('#ag-content-' + getId).addClass('is-active');

});